<template>
  <div class="po-profile">
    <div class="title-l title-l_black">Мой профиль</div>
    <div class="text">Укажите личные данные и информацию по заказу, после чего с вами свяжутся для подтверждения деталей заказа</div>
      <div
        class="po-profile__form"
        v-if="user"
      >
        <div class="form__cols">
          <div class="form__col form__col_gap-90-40">
            <div class="form__row">
              <div class="po-form__control">
                <label class="po-form__label" for="first-name">Имя</label>
                <input
                  type="text" class="po-form__input" id="first-name"
                  v-bind:placeholder="user.first_name"
                  v-model="user.first_name"
                >
              </div>
            </div>
            <div class="form__row">
              <div class="po-form__control">
                <label class="po-form__label" for="last-name">Фамилия</label>
                <input
                  type="text" class="po-form__input" id="last-name"
                  v-bind:placeholder="user.last_name"
                  v-model="user.last_name"
                >
              </div>
            </div>
            <div class="form__row">
              <div
                class="po-form__control"
                v-bind:class="{
                  // 'po-form__control_conformed': !$v.user.email.$invalid,
                  'po-form__control_rejected': $v.user.email.$error
                }"
              >
                <label class="po-form__label" for="email">Email</label>
                <input
                  type="text" class="po-form__input" id="email"
                  v-bind:placeholder="user.email"
                  v-model="$v.user.email.$model"
                >
                <div
                  class="po-form__error"
                  v-if="$v.user.email.$dirty && !$v.user.email.email"
                >
                  Пожалуйста, введите корректный адрес электронной почты.
                </div>
              </div>
            </div>
            <div class="form__row">
              <div
                class="po-form__control"
                v-bind:class="{
                  // 'po-form__control_conformed': !$v.user.phone.$invalid,
                  'po-form__control_rejected': $v.user.phone.$error
                }"
              >
                <label class="po-form__label" for="phone">Телефон</label>
                <vue-mask 
                  class="po-form__input"
                  id="phone"
                  name="phone"
                  v-model="$v.user.phone.$model"  
                  mask="+ZZ 000 000 00 ZZ" 
                  :raw="false"
                  :options="phoneMaskOptions"
                > 
                </vue-mask>
                <div
                  class="po-form__error"
                  v-if="$v.user.phone.$dirty && !$v.user.phone.required"
                >
                  Это поле необходимо заполнить
                </div>
                <div
                  class="po-form__error"
                  v-if="$v.user.phone.$dirty && $v.user.phone.required && !$v.user.phone.customPhone"
                >
                  Введите корректный номер телефона
                </div>
              </div>
            </div>
          </div>
          <div class="form__col form__col_gap-90-40">
            <div class="form__row">
              <div class="po-form__control">
                <label class="po-form__label" for="city">Город</label>
                <input
                  type="text" class="po-form__input" id="city"
                  v-bind:placeholder="user.city"
                  v-model="user.city"
                >
              </div>
            </div>
            <div class="form__row">
              <div class="po-form__control">
                <label class="po-form__label" for="street">Улица</label>
                <input
                  type="text" class="po-form__input" id="street"
                  v-bind:placeholder="user.street"
                  v-model="user.street"
                >
              </div>
            </div>
            <div class="form__row form__row_between">
              <div class="po-form__control po-form__control_half">
                <label class="po-form__label po-form__label_auto" for="house">Дом</label>
                <input
                  type="text" class="po-form__input po-form__input_auto" id="house"
                  v-bind:placeholder="user.house"
                  v-model="user.house"
                >
              </div>
              <div class="po-form__control po-form__control_half">
                <label class="po-form__label po-form__label_auto" for="flat">Квартира/Офис</label>
                <input
                  type="text" class="po-form__input po-form__input_auto" id="flat"
                  v-bind:placeholder="user.flat"
                  v-model="user.flat"
                >
              </div>
            </div>
            <div class="form__row">
              <div class="po-form__control">
                <label class="po-form__label" for="old_password">Пароль</label>
                <input
                  type="password" class="po-form__input" id="old_password"
                  v-model="user.old_password"
                >
              </div>
            </div>
            <div class="form__row form__row_no-flex">
              <div
                class="po-form__control"
                v-bind:class="{
                  'po-form__control_rejected': $v.user.password.$error
                }"
              >
                <label class="po-form__label po-form__label_auto" for="password">Новый пароль</label>
                <input
                  type="password" class="po-form__input" id="password"
                  v-model="$v.user.password.$model"
                >
                <div
                  class="po-form__error"
                  v-if="$v.user.password.$dirty && !$v.user.password.minLength"
                >
                  Пароль должен содержать минимум 8 символов
                </div>
                <div
                  class="po-form__error"
                  v-if="$v.user.password.$dirty && $v.user.password.minLength && !$v.user.password.strongPassword"
                >
                  Пароль должен содержать минимум 1 букву и 1 цифру
                </div>
                
              </div>
              <div class="po-form__notice">минимум одна цифра, минимум одна буква, не меньше 8 символов</div>
            </div>
          </div>
        </div>
        <div class="form__separator"></div>
        <div
          class="form__policy_right"
          v-if="formErrors.length"
        >
          <div
            class="form-error"
            v-for="(error, index) in formErrors"
            v-bind:key="index"
          >
            {{ error }}
          </div>
        </div>
        <div
          class="form__policy_right form-success"
          v-if="updateSuccess"
        >
          Сохранено успешно
        </div>
        <div class="form__flex form__flex_ac form__flex_jfe">
          <div class="form__policy form__policy_right" v-if="this.$parent.config" v-html="this.$parent.config.form_politics">
          </div>
          <div
            class="e-button e-button_ml_30"
            @click="submit"
          >
            Сохранить
          </div>
          <div
            class="e-button e-button_preview e-button_ml_30"
            @click="logout"
          >
            Выйти
          </div>
        </div>
    </div>
  </div>
</template>

<script>

import { required, email } from 'vuelidate/lib/validators'
import vueMask from 'vue-jquery-mask';

import { User } from '@/api/user';

// const customPhone = (value) => /\+[0-9]{11}/.test(value.replace(/[\s\-()]/g, ''));

// const strongPassword = (value) => (value == null) || (/\d/.test(value) && /[a-zA-Z]/.test(value));

export default {
  name: 'profile',
  components: {
    'vue-mask': vueMask
  },
  data: function() {
    return {
      user: {
        password: ''
      },
      phoneMaskOptions: {
        translation: {
          'Z': {
            pattern: /[0-9]/,
            optional: true
          },
        }
      },
      updateSuccess: false,
      formErrors: []
    }
  },
  methods: {
    logout: function() {
      this.$store.commit('removeToken');
      this.$router.go({name: 'login'});
    },
    submit: function() {
      let data = Object.assign({}, this.user);
      if(data.password.length == 0) {
        delete(data.password);
      }
      this.updateSuccess = false;
      this.formErrors = [];
      this.$v.$touch();
      if(!this.$v.$invalid) {
        User.update(this.user.id, data).then(response => {
          if (response.status == 200) {
            this.updateSuccess = true;
          } else if(response.status == 400) {
            this.formErrors = response.data.errors;
          }
        });
      }
    }
  },
  mounted: function() {
    User.get(this.$route.params.id).then(response => {
        this.user = Object.assign(response.data, this.user);
    });
  },
  validations: {
    user: {
      phone: {
        required,
        customPhone: (value) => /\+[0-9]{11}/.test(value.replace(/[\s\-()]/g, ''))
      },
      email: {
        email
      },
      password: {
        minLength: (value) => value.length == 0 || value.length >= 8,
        strongPassword: (value) => value.length == 0 || (/\d/.test(value) && /[a-zA-Z]/.test(value))
      },
    },
  },
}
</script>
<style lang="scss">
  .po-form__control_half+.po-form__control_half {
    margin-top: 0;
  }
  .form-success {
    color: #00cf4b;
  }
  .form-error {
    color: #cf0000;
  }
</style>